import React, { useEffect, useState } from "react";
import { Nav } from "react-bootstrap";
import { useSelector } from "react-redux";
import { TaxonomyType } from "../../../models/taxonomy-model";
import { retrieveTaxonomy } from "../../../redux/slice/taxonomy-slice";
import { RootState, useAppDispatch } from "../../../redux/store";

const TaxonomyTrail = (props: { detailPageTaxonomy: TaxonomyType[] | undefined, addSchema?: boolean }) => {
  const dispatch = useAppDispatch();
  const { data } = useSelector((state: RootState) => state.taxonomyList);

  useEffect(() => {
    dispatch(retrieveTaxonomy());
  }, [dispatch]);

  const [scriptHasRan, setScriptHasRan] = useState(false);
  useEffect(() => {

    if (!scriptHasRan) {
      setScriptHasRan(true);

      $(function () {
        $('#revealAllTerms').on('click', function () {
          $('.sectors .toHide').toggleClass('hide');
        })
      })
    }
  }, [scriptHasRan]);

  return (
    <>
      <TaxonomyStyles />
      <h4 style={{ lineHeight: "1em", marginTop: "5px", marginBottom: "8px" }}>Discover more of what matters to you</h4>
      {props.detailPageTaxonomy !== undefined ? (
        <div className="sectors">
          {props.detailPageTaxonomy?.length > 0 ? (
            props.detailPageTaxonomy?.map((item, index) => {
              return (<React.Fragment key={index}>
                {props.addSchema && <>
                  <span itemScope={true} itemProp="keywords" itemType="https://schema.org/DefinedTerm">
                    <Nav.Link href={`/search?taxonomy=${item.taxonomyId}`}
                      className={"btn btn-plain" +
                        ((item.taxonomyId === -1) ? " hide toHide " + item.categoryNodeName.split("__")[0] : " toShow")}>
                      <span itemProp="name">{item.categoryName}</span>
                    </Nav.Link>
                  </span>
                </>}
                {!props.addSchema && <>
                  <Nav.Link href={`/search?taxonomy=${item.taxonomyId}`}
                    className={"btn btn-plain" +
                      ((item.taxonomyId === -1) ? " hide toHide" : " toShow")}>
                    {item.categoryName}
                  </Nav.Link>
                </>
                }
              </React.Fragment>);
            })
          ) : (
            <div className="sectors text-left">No taxonomy</div>
          )}
        </div>
      ) : (
        <div className="sectors">
          {data?.length > 0 ? (
            data?.map((item, index) => {
              return (
                <Nav.Link key={index} href={`/search?taxonomy=${item.taxonomyId}`} className="btn btn-plain">
                  {item.categoryName}
                </Nav.Link>
              );
            })
          ) : (
            <div className="sectors text-left">No taxonomy</div>
          )}
        </div>
      )}
      <span id="revealAllTerms" style={{ height: "2px", display: "block", cursor: "default" }}>&nbsp; &nbsp;</span>
    </>
  );
};
const TaxonomyStyles = () => {
  return (
    <style>
      {`
          .libterms {
            border-color: #4BA33A;
          }
          .compframework {
            border-color: #94264F;
          }
        `}
    </style>
  );
}


export default TaxonomyTrail;
